import { defineNuxtPlugin } from '#app'
import posthog from 'posthog-js'
import { DEFAULT_FLAGS } from '~/domains/common/composables/useFeatureFlag'

export default defineNuxtPlugin(() => {
  const runtimeConfig = useRuntimeConfig()

  const posthogClient = posthog.init(runtimeConfig.public.postHog.publicKey, {
    api_host: runtimeConfig.public.postHog.host,
    capture_pageview: false, // we add manual pageview capturing below
    loaded: (posthog) => {
      if (import.meta.env.MODE === 'development') {
        posthog.debug()
      }
    },
    bootstrap: {
      featureFlags: DEFAULT_FLAGS,
    },
  })

  // Make sure that pageviews are captured with each route change
  const router = useRouter()

  router.afterEach((to) => {
    nextTick(() => {
      posthog.capture('$pageview', {
        current_url: to.fullPath,
      })
    })
  })

  return {
    provide: {
      posthog: () => posthogClient,
    },
  }
})
